import { IExportColumnModel } from "../../../../../shared/models";

export const ReportFiltersColumnList: IExportColumnModel[] = [
]